import { formatToCurrencyString } from "../helpers/number_formatter_helper";

export const renderValueIfNotEmpty = (value: string) => `${!!value && value !== '' ? value : '-'}`;

export const renderNumberWithCurrencyString = (value: number | string, options?: Intl.NumberFormatOptions) => {
    let res = renderValueIfNotEmpty(`${value}`);
    if (res !== '-') res = formatToCurrencyString(value);

    return res;
};